import { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import cx from 'classnames';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import styles from './ParentalConsentWarningModal.module.scss';

interface Props {
  isShow: boolean;
  onHide: () => void;
  onAcknowledge: (dismissForever: boolean) => void;
}

const ParentalConsentWarningModal = ({ isShow, onHide, onAcknowledge }: Props) => {
  const [dismissForever, setDismissForever] = useState(false);

  return (
    <Modal dialogClassName={cx('ModalDialog', styles.myDialog)} onHide={onHide} show={isShow} keyboard={true}>
      <Modal.Header className={styles.header} closeButton>
        <Modal.Title className={styles.title}>
          <h3 className='ModalDialogHeader'>Student account permissions</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.body} id='dialogBody'>
        By clicking ‘I agree’, you are indicating that you have the necessary parental consent, or are consenting on
        parents’ behalf, to use student accounts for this class.
      </Modal.Body>
      <Modal.Footer className='ModalDialogFooter'>
        <form className={styles.footer}>
          <Form.Check className={styles.form}>
            <div>
              <PrimaryButton onClick={myOnAcknowledge}>I Agree</PrimaryButton>
            </div>
            <div className={styles.inputContainer}>
              <Form.Check.Input
                type='checkbox'
                checked={dismissForever}
                onChange={() => setDismissForever(!dismissForever)}
              />
              <Form.Check.Label>Do not ask this question again</Form.Check.Label>
            </div>
          </Form.Check>
        </form>
      </Modal.Footer>
    </Modal>
  );

  function myOnAcknowledge() {
    onAcknowledge(dismissForever);
  }
};

export default ParentalConsentWarningModal;
